import { Hourglass } from "lucide-react";

export const IdleWarning = ({ seconds }) => (
  <div data-testid="idle-warning" className="fixed inset-x-0 bottom-0 z-30 flex items-center justify-center gap-3 border-t border-amber-400/50 bg-[#0b0f1a]/95 px-4 py-3 font-mono text-xs sm:text-sm uppercase tracking-[0.2em] text-amber-300 backdrop-blur-md">
    <Hourglass size={16} className="animate-pulse" />
    No activity // session ends in <span data-testid="idle-seconds" className="text-amber-100">0:{String(seconds).padStart(2, "0")}</span> - place an object to continue
  </div>
);
